import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ContactWidget() {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  // Auth error surfacing is handled by <AuthErrorModal /> globally.
  const submit = async () => {
    if (!form.name.trim() || !form.email.trim() || !form.message.trim())
      return toast.error("Semua field wajib diisi");
    setSending(true);
    try {
      await api.post("/contact", form);
      setSent(true);
      setForm({ name: "", email: "", message: "" });
      toast.success("Pesan terkirim · kami akan balas ke email kamu");
      setTimeout(() => setSent(false), 4000);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Gagal mengirim pesan");
    } finally { setSending(false); }
  };

  return (
    <>
      <button
        data-testid="contact-fab"
        onClick={() => setOpen((v) => !v)}
        aria-label="Hubungi Cookingin"
        style={{
          position: "fixed", right: 24, bottom: 24, zIndex: 90,
          minHeight: 56, padding: "0 22px", borderRadius: 999,
          background: open ? "#26221E" : "#1A17E0", color: "#fff",
          border: "none", boxShadow: "0 10px 30px rgba(38,34,30,0.24)",
          fontFamily: "'Nunito Sans', sans-serif", fontWeight: 700, fontSize: 14,
          cursor: "pointer", display: "flex", alignItems: "center", gap: 10,
        }}
      >
        <span style={{ fontSize: 18 }}>{open ? "×" : "✉"}</span>
        {open ? "Tutup" : "Hubungi Kami"}
      </button>

      {open && (
        <div
          data-testid="contact-panel"
          style={{
            position: "fixed", right: 24, bottom: 96, zIndex: 90,
            width: "min(380px, calc(100vw - 48px))", background: "#fff",
            borderRadius: 14, border: "1px solid rgba(38,34,30,0.12)",
            boxShadow: "0 24px 60px rgba(38,34,30,0.24)", overflow: "hidden",
            fontFamily: "'Nunito Sans', sans-serif", color: "#26221E",
          }}
        >
          <div style={{ padding: "16px 18px", background: "#1A17E0", color: "#fff" }}>
            <p className="font-mono-c" style={{ fontSize: 10, letterSpacing: "0.16em", opacity: 0.75, margin: 0, fontWeight: 500 }}>
              KONTAK COOKINGIN
            </p>
            <h3 style={{ fontFamily: "'Bitter', Georgia, serif", fontWeight: 800, fontSize: 20, margin: "4px 0 0" }}>
              Punya pertanyaan atau ingin bawa Cookingin ke kantormu?
            </h3>
          </div>
          <div style={{ padding: 18 }}>
            {sent ? (
              <div data-testid="contact-sent" style={{ padding: "18px 14px", background: "#E7F6EC", color: "#2F7A3D", borderRadius: 8, fontSize: 13, fontWeight: 600 }}>
                Terima kasih — pesanmu sudah masuk ke inbox tim kami. Kami balas via email dalam 1×24 jam.
              </div>
            ) : (
              <>
                <input
                  data-testid="contact-name"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  placeholder="Nama"
                  style={contactInp}
                  maxLength={120}
                />
                <input
                  data-testid="contact-email"
                  type="email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  placeholder="Email kamu"
                  style={contactInp}
                  maxLength={160}
                />
                <textarea
                  data-testid="contact-message"
                  value={form.message}
                  onChange={(e) => setForm({ ...form, message: e.target.value })}
                  placeholder="Pesan / pertanyaanmu…"
                  style={{ ...contactInp, minHeight: 100, resize: "vertical" }}
                  maxLength={2000}
                />
                <button
                  data-testid="contact-submit"
                  onClick={submit}
                  disabled={sending}
                  style={{
                    width: "100%", minHeight: 46, background: "#E8823A", color: "#fff",
                    border: "none", borderRadius: 4, fontWeight: 700, fontSize: 14,
                    cursor: sending ? "not-allowed" : "pointer", opacity: sending ? 0.7 : 1,
                  }}
                >
                  {sending ? "Mengirim…" : "Kirim Pesan"}
                </button>
                <p style={{ fontSize: 11, color: "#9A9084", margin: "8px 0 0", textAlign: "center" }}>
                  Kami balas langsung ke email kamu.
                </p>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}

const contactInp = {
  width: "100%", padding: "10px 12px", border: "1px solid rgba(38,34,30,0.18)",
  borderRadius: 4, marginBottom: 10, fontSize: 14, fontFamily: "inherit",
  boxSizing: "border-box", color: "#26221E", background: "#fff",
};
